import { getNimbuxCaseSummary } from 'features/common/services';
import { findContactsDataByDealID } from 'services';
import { extractErrorMessage } from 'features/quotation/helpers';

export interface PaymentContactData {
	name: string;
	email: string;
	phone: string;
}

export const fetchPaymentContactData = async (
	crmTicket: number,
	isBitrixDeal: boolean,
): Promise<PaymentContactData> => {
	if (isBitrixDeal) {
		const response = await findContactsDataByDealID(crmTicket);
		const first = response.data?.[0];
		if (!first?.email && !first?.phone) {
			throw new Error('El deal no tiene contacto con email o teléfono.');
		}
		return {
			name: first.name?.trim() || 'Cliente',
			email: first.email || '',
			phone: first.phone || '',
		};
	}

	const response = await getNimbuxCaseSummary(crmTicket);
	if (!response.data?.client) {
		throw new Error('El caso no tiene cliente asociado. Asociá un cliente en el CRM.');
	}

	const client = response.data.client;
	if (!client.email && !client.whatsappNumber) {
		throw new Error('Completá el email o WhatsApp del cliente en el CRM.');
	}

	return {
		name: `${client.firstName ?? ''} ${client.lastName ?? ''}`.trim() || 'Cliente',
		email: client.email || '',
		phone: client.whatsappNumber || '',
	};
};

export const fetchPaymentContactDataSafe = async (
	crmTicket: number,
	isBitrixDeal: boolean,
): Promise<PaymentContactData | null> => {
	try {
		return await fetchPaymentContactData(crmTicket, isBitrixDeal);
	} catch (error: unknown) {
		console.error('fetchPaymentContactData:', extractErrorMessage(error));
		return null;
	}
};
